/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Difference chart uses the raw A/B shares already supplied to the table. */
(function(){
 'use strict';
 var table=document.querySelector('[data-por-table]'),source=document.querySelector('[data-por-report]'),box=document.querySelector('[data-por-difference-chart]');
 if(!table||!source||!box)return;
 var report;try{report=JSON.parse(source.textContent);}catch(_){return;}
 var en=/^en(?:-|$)/i.test(document.documentElement.lang||''),ns='http://www.w3.org/2000/svg';
 function el(tag,attrs,text){var n=document.createElementNS(ns,tag);Object.keys(attrs||{}).forEach(function(k){n.setAttribute(k,String(attrs[k]));});if(text!=null)n.textContent=text;return n;}
 function f(n){return n==null?'—':n.toFixed(1).replace('.',jst("pages_porownanie_okresow_js.26e1d9150da7"));}
 function draw(){
  var order=Array.from(table.tBodies[0].rows).map(function(r){return Number(r.dataset.porRow);});
  var map=new Map(report.liczby.map(function(r){return[r.n,r];})),rows=order.map(function(n){return map.get(n);});
  var max=Math.max.apply(null,rows.map(function(r){return r.roznica_pp==null?0:Math.abs(r.roznica_pp);})),width=42+rows.length*14;
  var svg=el('svg',{viewBox:'0 0 '+width+' 260',width:width,height:260,role:'img','aria-label':jst("pages_porownanie_okresow_js.3b3949165a11"),'data-por-diff-svg':''});
  svg.appendChild(el('line',{x1:36,x2:width-8,y1:130,y2:130,stroke:'currentColor','data-por-zero':''}));
  [max,0,-max].forEach(function(t,i){svg.appendChild(el('text',{x:30,y:34+i*100,'text-anchor':'end',fill:'currentColor','font-size':10},f(t)));});
  rows.forEach(function(r,i){
   var x=42+i*14,delta=r.roznica_pp,h=delta==null||!max?0:Math.abs(delta)*100/max;
   var label=r.n+': A '+(r.udzialA==null?'—':f(r.udzialA*100)+'%')+' (N='+report.A.N+'), B '+(r.udzialB==null?'—':f(r.udzialB*100)+'%')+' (N='+report.B.N+'); Δ '+f(delta)+' p.p.';
   var g=el('g',{'data-por-diff-point':r.n,'data-difference':delta==null?'':delta,tabindex:0,'aria-label':label});g.appendChild(el('title',{},label));
   if(delta!=null)g.appendChild(el('rect',{x:x,y:delta>=0?130-h:130,width:10,height:h,class:delta>=0?'stat-gra-fill':'stat-negative-fill'}));
   else g.appendChild(el('text',{x:x,y:130,fill:'currentColor','font-size':10},'—'));
   g.appendChild(el('text',{x:x+5,y:246,'text-anchor':'middle',fill:'currentColor','font-size':9},r.n));svg.appendChild(g);
  });
  box.replaceChildren(svg);
 }
 draw();document.querySelectorAll('[data-por-sort]').forEach(function(b){b.addEventListener('click',draw);});
})();
